import { InvokeApi } from "../../Utils/InvokeApi";

export const Login = async (data) => {
  const requestObj = {
    path: `/login`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};
export const LogoutApi = async (data) => {
  const requestObj = {
    path: `api/logout`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};
